import { useParams } from 'react-router-dom';
import { useChannel } from '@/hooks/api/useChannel';
import { useChannelPost } from '@/hooks/api/useChannelPost';
import { Menu } from '@/components/layout/Menu';
import { Body } from '@/components/channel_post/Body';
import { Header as ChannelPostHeader } from '@/components/channel_post/Header';
import { RelCreators } from '@/components/channel_post/RelCreators';
import { Information } from '@/components/channel_post/Information';
import { AppLayout } from '@/components/layout/AppLayout';
import { Error404 } from '@/features/404';
import { Description } from '@/components/channel_post/Description';
import { ChannelPostComments } from '@/components/channel_post/ChannelPostComments';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { NumberCompactFormat } from '@/components/common/NumberCompactFormat';
import ReactTimeAgo from 'react-time-ago';
import { Playlists } from '@/components/features/top/Playlists';
import { Channels } from '@/components/features/top/Channels';
import { Features } from '@/components/features/top/Features';
import { Rankings } from '@/components/features/channels/[cid]/channel_posts/[id]/Rankings';
import { Helmet } from 'react-helmet-async';

export const ChannelPost = () => {
  const params = useParams<{ cid: string; id: string }>();
  const { data: channel, isError: isChannelError } = useChannel(params.cid!);
  const { data: channel_post, isError: isChannelPostError } = useChannelPost(params.cid!, params.id!);

  if (isChannelError || isChannelPostError) return <Error404 />;

  if (channel == null || channel_post == null) return <></>;

  return (
    <AppLayout>
      <Helmet>
        <title>{channel_post.title} | ヘブンTV</title>
      </Helmet>
      <div className="global-container">
        <Menu />

        <div className="content-main creator top" style={{ paddingBottom: 0 }}>
          <section className="post">
            <div className="post">
              {/*<ChannelPostHeader channel_post={channel_post} />*/}
              <Information channel_post={channel_post} />
              <Body playable={true} channel_post={channel_post} />
              <RelCreators channel_post={channel_post} />
              <ChannelPostHeader channel_post={channel_post} />
              <Description channel_post={channel_post} />
            </div>
          </section>
          <ChannelPostComments channel={channel} channel_post={channel_post} />

          <div className="top-movies" style={{ paddingBottom: 30 }}>
            <Rankings />
          </div>
        </div>
      </div>
    </AppLayout>
  );
};
